export default {
  computed: {
    questionUiV2Enabled() {
      return this.$store.getters['app/questionUiV2Enabled'];
    },
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    getCorrectRouteName(flashcardType) {
      if (flashcardType === 'Flipcard' && this.currentRouteName === 'categories#flashcard-v2') return 'categories#flashcard';
      if (flashcardType === 'Flipcard' && this.currentRouteName === 'categories#flashcard') return 'categories#flashcard';
      if (!this.questionUiV2Enabled && this.currentRouteName === 'categories#flashcard-v2') return 'categories#flashcard';
      if (this.questionUiV2Enabled && this.currentRouteName === 'categories#flashcard') return 'categories#flashcard-v2';
      if (this.questionUiV2Enabled && this.currentRouteName === 'scenario#flashcard') return 'scenario#flashcard-v2';
      if (!this.questionUiV2Enabled && this.currentRouteName === 'scenario#flashcard-v2') return 'scenario#flashcard';
      if (!this.questionUiV2Enabled && this.currentRouteName === 'qotd#flashcard-v2') return 'qotd#index';
      if (this.questionUiV2Enabled && this.currentRouteName === 'qotd#index') return 'qotd#flashcard-v2';
      return this.currentRouteName;
    },
  },
};
